/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  GET_EMPLOYEEBYUSERID(state, user) {
    state.employeeProfile = user;
  },
  GET_ALL_EMPLOYEE(state, payload) {
    console.log("GETALLEMPLOYEE");
    console.log(payload);
    state.allEmployee = payload;
  },
  GET_ALL_APPROVERSBYUSERID(state, payload) {
    state.employeeApprovers = payload;
  },
  UPDATE_ACCOUNTPROFILE(state, item) {
    state.employeeProfile = item;
  },
  // /////////////////////////////////////////////
  // ROLES
  // /////////////////////////////////////////////
  GET_ALLROLES(state, item) {
    state.getAllRoles = item;
  },
  ADD_ACCREDITATION(state, item) {
    state.employeeAccreditation.unshift(item);
  },
  UPDATE_ACCREDITATION(state, item) {
    const index = state.employeeAccreditation.findIndex(
      (e) => e.id === item.id
    );
    Object.assign(state.employeeAccreditation[index], item);
  },
  DELETE_ACCREDITATION(state, item) {
    state.employeeAccreditation = item;
  },
  GET_ALL_ACCREDITATION(state, payload) {
    state.employeeAccreditation = payload;
  },
  ADD_APPROVERS(state, item) {
    state.employeeApprovers.unshift(item);
  },
  UPDATE_APPROVERS(state, item) {
    const index = state.employeeApprovers.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeApprovers[index], item);
  },
  DELETE_APPROVERS(state, item) {
    state.employeeApprovers = item;
  },
  GET_ALL_APPROVERS(state, payload) {
    state.employeeApprovers = payload;
  },
  ADD_ASSOCIATION(state, item) {
    state.employeeAssociation.unshift(item);
  },
  UPDATE_ASSOCIATION(state, item) {
    const index = state.employeeAssociation.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeAssociation[index], item);
  },
  DELETE_ASSOCIATION(state, item) {
    state.employeeAssociation = item;
  },
  GET_ALL_ASSOCIATION(state, payload) {
    state.employeeAssociation = payload;
  },

  ADD_BENEFITS(state, item) {
    state.employeeBenefits.unshift(item);
  },
  UPDATE_BENEFITS(state, item) {
    const index = state.employeeBenefits.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeBenefits[index], item);
  },
  DELETE_BENEFITS(state, item) {
    state.employeeBenefits = item;
  },
  GET_ALL_BENEFITS(state, payload) {
    state.employeeBenefits = payload;
  },

  ADD_BANKINFORMATION(state, item) {
    state.employeeBankInformation.unshift(item);
  },
  UPDATE_BANKINFORMATION(state, item) {
    const index = state.employeeBankInformation.findIndex(
      (e) => e.id === item.id
    );
    Object.assign(state.employeeBankInformation[index], item);
  },
  DELETE_BANKINFORMATION(state, item) {
    state.employeeBankInformation = item;
  },
  GET_ALL_BANKINFORMATION(state, payload) {
    state.employeeBankInformation = payload;
  },

  ADD_CLAIMSLIMIT(state, item) {
    state.employeeClaimsLimit.unshift(item);
  },
  UPDATE_CLAIMSLIMIT(state, item) {
    const index = state.employeeClaimsLimit.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeClaimsLimit[index], item);
  },
  DELETE_CLAIMSLIMIT(state, item) {
    state.employeeClaimsLimit = item;
  },
  GET_ALL_CLAIMSLIMIT(state, payload) {
    state.employeeClaimsLimit = payload;
  },

  ADD_CONTACTREFERENCES(state, item) {
    state.employeeContactReferences.unshift(item);
  },
  UPDATE_CONTACTREFERENCES(state, item) {
    const index = state.employeeContactReferences.findIndex(
      (e) => e.id === item.id
    );
    Object.assign(state.employeeContactReferences[index], item);
  },
  DELETE_CONTACTREFERENCES(state, item) {
    state.employeeContactReferences = item;
  },
  GET_ALL_CONTACTREFERENCES(state, payload) {
    state.employeeContactReferences = payload;
  },

  ADD_EDUCATION(state, item) {
    state.employeeEducation.unshift(item);
  },
  UPDATE_EDUCATION(state, item) {
    const index = state.employeeEducation.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeEducation[index], item);
  },
  DELETE_EDUCATION(state, item) {
    state.employeeEducation = item;
  },
  GET_ALL_EDUCATION(state, payload) {
    state.employeeEducation = payload;
  },

  ADD_FAMILYINFORMATION(state, item) {
    state.employeeFamilyInformation.unshift(item);
  },
  UPDATE_FAMILYINFORMATION(state, item) {
    const index = state.employeeFamilyInformation.findIndex(
      (e) => e.id === item.id
    );
    Object.assign(state.employeeFamilyInformation[index], item);
  },
  DELETE_FAMILYINFORMATION(state, item) {
    state.employeeFamilyInformation = item;
  },
  GET_ALL_FAMILYINFORMATION(state, payload) {
    state.employeeFamilyInformation = payload;
  },

  ADD_IDENTIFICATION(state, item) {
    state.employeeIdentification.unshift(item);
  },
  UPDATE_IDENTIFICATION(state, item) {
    state.employeeIdentification = item;
  },
  DELETE_IDENTIFICATION(state, item) {
    state.employeeIdentification = item;
  },
  GET_ALL_IDENTIFICATION(state, payload) {
    state.employeeIdentification = payload;
  },

  ADD_INFORMATION(state, item) {
    state.employeeInformation.unshift(item);
  },
  UPDATE_INFORMATION(state, item) {
    state.employeeInformation = item;
  },
  DELETE_INFORMATION(state, item) {
    state.employeeInformation = item;
  },
  GET_ALL_INFORMATION(state, payload) {
    state.employeeInformation = payload;
  },

  ADD_JOBHISTORY(state, item) {
    state.employeeJobHistory.unshift(item);
  },
  UPDATE_JOBHISTORY(state, item) {
    const index = state.employeeJobHistory.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeJobHistory[index], item);
  },
  DELETE_JOBHISTORY(state, item) {
    state.employeeJobHistory = item;
  },
  GET_ALL_JOBHISTORY(state, payload) {
    state.employeeJobHistory = payload;
  },

  ADD_LEAVEBALANCE(state, item) {
    state.employeeLeaveBalance.unshift(item);
  },
  UPDATE_LEAVEBALANCE(state, item) {
    const index = state.employeeLeaveBalance.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeLeaveBalance[index], item);
  },
  DELETE_LEAVEBALANCE(state, item) {
    state.employeeLeaveBalance = item;
  },
  GET_ALL_LEAVEBALANCE(state, payload) {
    state.employeeLeaveBalance = JSON.parse(JSON.stringify(payload));
  },

  ADD_LEAVEBENEFITS(state, item) {
    state.employeeLeaveBenefits.unshift(item);
  },
  UPDATE_LEAVEBENEFITS(state, item) {
    const index = state.employeeLeaveBenefits.findIndex(
      (e) => e.id === item.id
    );
    Object.assign(state.employeeLeaveBenefits[index], item);
  },
  DELETE_LEAVEBENEFITS(state, item) {
    state.employeeLeaveBenefits = item;
  },
  GET_ALL_LEAVEBENEFITS(state, payload) {
    state.employeeLeaveBenefits = payload;
  },

  ADD_MEDICAL(state, item) {
    state.employeeMedical.unshift(item);
  },
  UPDATE_MEDICAL(state, item) {
    const index = state.employeeMedical.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeMedical[index], item);
  },
  DELETE_MEDICAL(state, item) {
    state.employeeMedical = item;
  },
  GET_ALL_MEDICAL(state, payload) {
    state.employeeMedical = payload;
  },

  ADD_PERFORMANCE(state, item) {
    state.employeePerformance.unshift(item);
  },
  UPDATE_PERFORMANCE(state, item) {
    const index = state.employeePerformance.findIndex((e) => e.id === item.id);
    Object.assign(state.employeePerformance[index], item);
  },
  DELETE_PERFORMANCE(state, item) {
    state.employeePerformance = item;
  },
  GET_ALL_PERFORMANCE(state, payload) {
    state.employeePerformance = payload;
  },

  ADD_SALARYINFORMATION(state, item) {
    state.employeeSalaryInformation.unshift(item);
  },
  UPDATE_SALARYINFORMATION(state, item) {
    state.employeeSalaryInformation = item;
  },
  DELETE_SALARYINFORMATION(state, item) {
    state.employeeSalaryInformation = item;
  },
  GET_ALL_SALARYINFORMATION(state, payload) {
    state.employeeSalaryInformation = payload;
  },

  ADD_SALARY(state, item) {
    state.employeeSalary.unshift(item);
  },
  UPDATE_SALARY(state, item) {
    const index = state.employeeSalary.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeSalary[index], item);
  },
  DELETE_SALARY(state, item) {
    state.employeeSalary = item;
  },
  GET_ALL_SALARY(state, payload) {
    state.employeeSalary = payload;
  },

  ADD_TRAINING(state, item) {
    state.employeeTraining.unshift(item);
  },
  UPDATE_TRAINING(state, item) {
    const index = state.employeeTraining.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeTraining[index], item);
  },
  DELETE_TRAINING(state, item) {
    state.employeeTraining = item;
  },
  GET_ALL_TRAINING(state, payload) {
    state.employeeTraining = payload;
  },

  ADD_VIOLATION(state, item) {
    state.employeeViolation.unshift(item);
  },
  UPDATE_VIOLATION(state, item) {
    const index = state.employeeViolation.findIndex((e) => e.id === item.id);
    Object.assign(state.employeeViolation[index], item);
  },
  DELETE_VIOLATION(state, item) {
    state.employeeViolation = item;
  },
  GET_ALL_VIOLATION(state, payload) {
    state.employeeViolation = payload;
  },
  CURRENT_SCHEDULE(state, items) {
    state.getAllEmployeeSchedule = items;
  },
  GET_EMPLOYEESCHEDULEBYDATETODAY(state, items) {
    state.scheduleToday = items;
  },

  GET_PREVCOMPANY(state, data) {
    state.prevCompanyYTD = data;
  },

  ADD_PREVIOUS_COMPANY(state, payload) {
    state.prevCompanyYTD.push(payload);
    console.log(state.prevCompanyYTD);
  },

  UPDATE_PREVIOUSCOMPANY(state, items) {
    const index = state.prevCompanyYTD.findIndex((e) => e.id === items.id);
    Object.assign(state.prevCompanyYTD[index], {
      companyAddress: items.companyAddress,
      companyName: items.companyName,
      companyTIN: items.companyTIN,
      companyZipCode: items.companyZipCode,
      prevYTDBasicPay: items.prevYTDBasicPay,
      prevYTDGrossPay: items.prevYTDGrossPay,
      prevYTDNonTaxableBonus: items.prevYTDNonTaxableBonus,
      prevYTDNonTaxableEarnings: items.prevYTDNonTaxableEarnings,
      prevYTDNonTaxablePremium: items.prevYTDNonTaxablePremium,
      prevYTDTaxableBonus: items.prevYTDTaxableBonus,
      prevYTDTaxableEarnings: items.prevYTDTaxableEarnings,
      prevYTDTaxablePremium: items.prevYTDTaxablePremium,
      prevYTDWHTax: items.prevYTDWHTax,
      ytdBasicPay: items.ytdBasicPay,
      ytdGrossPay: items.ytdGrossPay,
      ytdNonTaxableBonus: items.ytdNonTaxableBonus,
      ytdNonTaxableEarnings: items.ytdNonTaxableEarnings,
      ytdNonTaxablePremium: items.ytdNonTaxablePremium,
      ytdTaxableBonus: items.ytdTaxableBonus,
      ytdTaxableEarnings: items.ytdTaxableEarnings,
      ytdTaxablePremium: items.ytdTaxablePremium,
      ytdwhTax: items.ytdwhTax,
    });
  },
};
